module.exports = __webpack_public_path__ + "static/media/renata_cristiane_fusverk_da_silva.08073d4e.jpg";